<ul nz-menu nzSelectable class="panel">
    <li nz-menu-item *ngFor="let item of options; let i = index" class="item" [class]="value.includes(item[valueKey]) ? 'checked-item' : ''" (click)="handleSelect(item, i)">
        <div class="label">{{ item[labelKey] }}</div>
        <div *ngIf="value.includes(item[valueKey])" nz-icon nzType="check" nzTheme="outline" class="icon"></div>
    </li>
</ul>